export const PanelMenuSeparator = () => <li className="p-menu-separator" role="separator"></li>;
